import { render, staticRenderFns } from "./ContactInputItem.vue?vue&type=template&id=6b9b5e05&"
import script from "./ContactInputItem.vue?vue&type=script&lang=js&"
export * from "./ContactInputItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports